module.exports = __webpack_public_path__ + "img/59_9.d0f0e00b.png";